<template>
    <div v-show="isLoaded" class="dRitualRose-container" v-observe-visibility="startAnimate">
        <div class="dRitualRose-title">
            <h2 class="title" :class="{animate: animate}">Ritual del Servido</h2>
        </div>
        <img class="dRitualRose-manzana" v-observe-visibility="startAnimate" :src="manzana" :class="{animate: animate}" alt="Manzana">
        <div class="dFlex-container">
            <div class="dImagen Imagen-1" :class="{animate: animate}">
                <img class="" :src="paso1" alt="Paso 1">
            </div>
            <div class="dImagen Imagen-2" :class="{animate: animate}">
                <img class="" :src="paso2" alt="Paso 2">
            </div>
            <div class="dImagen Imagen-3" :class="{animate: animate}">
                <img class="" :src="paso3" alt="Paso 3">
            </div>
        </div>
    </div>
</template>

<script>
import manzana from '@/assets/rose-apple/manzana.png';
import paso1 from '@/assets/rose-apple/1ROSEAPPLE.png';
import paso2 from '@/assets/rose-apple/2ROSEAPPLE.png';
import paso3 from '@/assets/rose-apple/3ROSEAPPLE.png';
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
    name: "D_RitualRose",
    data() {
        return {
            manzana,
            paso1,
            paso2,
            paso3,
            animate: false,
            isSafari: false,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        }
    },
    components: { },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/RoseApple/D_RitualRose.scss";
</style>